/* 手機上的左滑卡片（照 Apple「看這裡，畫重點」那一段）。

   捲動與吸附交給 CSS 的 scroll-snap 做——原生的手感最好，也不用管觸控事件。
   這支只負責上面沒有的三件事：圓點、播放／暫停、自動前進。

   只在手機生效；桌機那邊本來就是並排的格線，不需要滑。 */
if (!window.__tsSwipeInit) {
  window.__tsSwipeInit = 1;
  (function () {
    var SELECTORS = [".ts-air .tests"];      // 之後要加別段，往這裡加就好
    var DELAY = 5200;
    // 桌機也是同一條可滑動的軌道，所以控制列兩邊都要有
    var mq = matchMedia("(min-width:0px)");
    var reduce = matchMedia("(prefers-reduced-motion:reduce)");

    function setup(track) {
      if (track.__swipe) return track.__swipe;
      var cards = [].slice.call(track.children);
      if (cards.length < 2) return null;

      var ctl = document.createElement("div");
      ctl.className = "ts-swipe__ctl";
      var dots = document.createElement("div");
      dots.className = "ts-swipe__dots";
      var btns = cards.map(function (c, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "第 " + (i + 1) + " 張");
        b.addEventListener("click", function () { go(i); stop(); });
        dots.appendChild(b);
        return b;
      });
      var play = document.createElement("button");
      play.type = "button";
      play.className = "ts-swipe__play";
      ctl.appendChild(dots);
      ctl.appendChild(play);
      track.parentNode.insertBefore(ctl, track.nextSibling);

      var timer = null, cur = 0;

      function go(i) {
        cur = (i + cards.length) % cards.length;
        var c = cards[cur];
        track.scrollTo({
          left: c.offsetLeft - (track.clientWidth - c.clientWidth) / 2,
          behavior: "smooth"
        });
      }
      function mark() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid);
          if (d < bd) { bd = d; best = i; }
        });
        cur = best;
        btns.forEach(function (b, i) { b.classList.toggle("is-on", i === best); });
      }
      function start() {
        if (timer || reduce.matches) return;
        timer = setInterval(function () { go(cur + 1); }, DELAY);
        play.classList.add("is-playing");
        play.setAttribute("aria-label", "暫停");
      }
      function stop() {
        clearInterval(timer); timer = null;
        play.classList.remove("is-playing");
        play.setAttribute("aria-label", "播放");
      }
      play.addEventListener("click", function () { timer ? stop() : start(); });
      // 使用者自己滑了就別再自動跑，免得跟他搶
      track.addEventListener("pointerdown", stop);
      track.addEventListener("scroll", function () {
        clearTimeout(track.__t);
        track.__t = setTimeout(mark, 90);
      }, { passive: true });

      mark(); stop();
      track.__swipe = { ctl: ctl, start: start, stop: stop, mark: mark };
      return track.__swipe;
    }

    function apply() {
      SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (track) {
          var s = setup(track);
          if (!s) return;
          if (mq.matches) {
            s.ctl.hidden = false;
            s.mark();
            // 捲到看得見才開始自動播，沒看到就別空轉
            if (!track.__io) {
              track.__io = new IntersectionObserver(function (es) {
                es.forEach(function (e) { e.isIntersecting ? s.start() : s.stop(); });
              }, { threshold: 0.4 });
              track.__io.observe(track);
            }
          } else {
            s.ctl.hidden = true;
            s.stop();
            if (track.__io) { track.__io.disconnect(); track.__io = null; }
          }
        });
      });
    }

    function boot() { apply(); mq.addEventListener("change", apply); }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else { boot(); }
  })();
}
